import { RemoteAddressControler } from "../../../../data/usecases/address/remote-address-controller";
import { AddressController } from "../../../../domain/models/address.model";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteAddresss = (): AddressController =>
  new RemoteAddressControler("/address", makeAxiosHttpClient());
